<a class="dropdown-item dropdown-notifications-item" [routerLink]="">
	@if (message.image) {
		<img class="dropdown-notifications-item-img" [src]="message.image" />
	} @else if (message.icon) {
		<fa-icon [icon]="message.icon" size="2x" class="pe-3" [ngClass]="message.color ?? 'text-dark'"></fa-icon>
	}

	<div class="dropdown-notifications-item-content text-wrap">
		<div class="dropdown-notifications-item-content-text" [ngClass]="message.color ?? 'text-dark'">
			{{ message.text }}
		</div>
		<div class="dropdown-notifications-item-content-details">
			{{ message.details }}
			@if (message?.data?.created) {
				<small class="d-inline-block w-100 text-muted mt-2">
					{{ message?.data?.created | date: 'dd/MM/yyyy HH:ss' }}
				</small>
			}
		</div>
	</div>
</a>
